import { CanvasItem } from "../clases/CanvasItem";
import { Connection } from "../clases/Connection";
import { IContainer } from "../interfaces/Container";
import { generateUUID } from "./utils";
import { INeo4j } from "../interfaces/Neo4j";
import { DBItem } from "../interfaces/Record";
import { AbstractShape } from "../abstract/Shape";
import { ConnectionRenderer } from "../abstract/ConnectionRenderer";
import { Camera } from "../clases/Camera";

export function getContainerWithId(id: string, containers: IContainer[]): IContainer | undefined {
    for (const item of containers) {
        if (item.id === id) {
            return item;
        }
        let response = getContainerWithId(id, item.children);
        if (response) return response;
        continue;
    }
    return undefined;
}

export function parentExistOnList(item: AbstractShape, list: AbstractShape[]) {
    return getShapeWithId(item.id, list) ? true : false;
}

export function getShapeWithId(id: string, containers: AbstractShape[]): AbstractShape | undefined {
    for (const item of containers) {
        if (item.id === id) {
            return item;
        }
        let response = getShapeWithId(id, item.children);
        if (response) return response;
        continue;
    }
    return undefined;
}

export function recursiveChangeFilling(items: AbstractShape[]){
    for (const item of items) {
        item.fill = true;
        if (item.children.length > 0) recursiveChangeFilling(item.children);
    }
}

export function getShapeWithNodeId(id: string, containers: AbstractShape[]): AbstractShape | undefined {
    for (const item of containers) {
        
        // if(label){
        //     if (item.dbData.elementId === id) {
        //         return item;
        //     }
        //     // if (item.dbData.elementId === id && item.dbData.label === label) {
        //     //     return item;
        //     // }
        // }
        if(!item.dbData) continue;
        if (item.dbData.elementId === id) {
            return item;
        }
    }
    for (const item of containers) {
        let response = getShapeWithNodeId(id, item.children);
        if (response) return response;
        continue;
    }
    return undefined;
}

export function getAllShapesWithNodeId(id: string, containers: AbstractShape[], label: string, list: AbstractShape[] = []): AbstractShape[] {
    for (const item of containers) {
        // if (item.dbData.elementId === id && item.dbData.label === label) {
        //     list.push(item);
        // }
        if (item.dbData.elementId === id) {
            list.push(item);
        }
        getAllShapesWithNodeId(id, item.children, label, list);
    }
    return list;
}

export function getAllShapesWithLabels(labels: string[], containers: AbstractShape[], list: AbstractShape[] = []): AbstractShape[] {
    for (const item of containers) {
        let array1 = [...item.dbData.labels].sort();
        let array2 = [...labels].sort();
        if (arraysEqual(array1, array2)) {
            list.push(item);
        }
        getAllShapesWithLabels(labels, item.children, list);
    }
    return list;
}

export function getAllShapesWithPropierty(propierty: string, containers: AbstractShape[], list: AbstractShape[] = []): AbstractShape[] {
    for (const item of containers) {
        if (item.getGroup() === propierty) {
            list.push(item);
        }
        getAllShapesWithPropierty(propierty, item.children, list);
    }
    return list;
}

function arraysEqual(arr1: string[], arr2: string[]) {
    if (arr1.length !== arr2.length) { return false; }
    for (let i = 0; i < arr1.length; i++) {
        if (arr1[i] !== arr2[i]) { return false; }
    } return true;
}

export function createCanvasItemFromIContainer(item: IContainer, depth: number, mainItems: AbstractShape[], parent?: AbstractShape) {
    let container = new CanvasItem(item.id, depth, parent);
    container.setContainer(item);
    if (item.children) {
        for (const child of item.children) {
            createCanvasItemFromIContainer(child, depth + 1, mainItems, container);
        }
    }
    if (parent) {
        parent.addChild(container);
    } else {
        mainItems.push(container);
    }
}

export function createCanvasItem(node: DBItem) {
    // let labels = node.labels;
    let item = new CanvasItem(generateUUID(), 0);
    // item.setLabels(labels);
    item.setDBData(node);
    return item;
}

export function conditionShow(connection: ConnectionRenderer, itm1: AbstractShape, itm2: AbstractShape){
    if (!connection.show) return false;
    if (itm1.parent && itm2.parent) {
        if (itm1.parent!.fill === true && itm2.parent!.fill === true) return false;
    }
    return !(itm1.id === itm2.id);
}

export function createIContainers(list: AbstractShape[], compare: AbstractShape[]): IContainer[] {
    let containerList: IContainer[] = [];
    for (const item of list) {
        // let exist = getShapeWithId(item.id, compare);
        // if(!exist) continue;
        let container = item.transformToContainer();
        if (item.children) {
            let children = createIContainers(item.children, compare);
            container.children = children;
        }
        containerList = [...containerList, container];
    }
    return containerList;
}

export function makeContainers(containers: IContainer[], mainItems:AbstractShape[]) {
    for (const item of containers) {
        createCanvasItemFromIContainer(item, 0, mainItems);
    }
}

export function removeChildItemsFromMainList(items: AbstractShape[]): AbstractShape[] {
    const childSet = new Set<AbstractShape>();

    function collectChildren(item: AbstractShape) {
        for (const child of item.children) {
            childSet.add(child);
            collectChildren(child); // Recursively check children of children
        }
    }

    // Collect all children from every top-level item
    for (const item of items) {
        collectChildren(item);
    }

    // Return a filtered list, removing those that were found as children
    return items.filter(item => !childSet.has(item));
}